import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';

// Issue #194: Ein ungefilterter Count ueber die Data API
// (`products.select('*', { count: 'exact', head: true })`) prueft die
// RLS-Join-Kette (products -> merchant_centers -> google_accounts) pro Zeile
// und riss bei Multi-MC-Konten das 8s-statement_timeout der Rolle
// authenticated (gemessen in Produktion: HEAD /rest/v1/products?select=* ->
// PostgREST 57014 nach 8005 ms bei ~19k sichtbaren Produkten). Die Consumer
// (useEnforcement -> UpgradeBanner/UpgradeModal/PostFetchRecommendation)
// brauchen eine EXAKTE kontoweite Zahl (Plan-Sizing + "N Produkte > Limit
// M"-Copy), `count: 'estimated'` ist deshalb keine Option. Stattdessen zaehlt
// die SECURITY-DEFINER-RPC `count_user_products()` mit direktem
// Ownership-Join (siehe supabase/migrations/20260817120000_count_user_products_rpc.sql):
// gemessen ~293ms fuer 445.751 Produkte, Index-Only-Scan.
export function useTotalProducts() {
  const { user } = useAuth();

  const { data: totalProducts = 0, isLoading } = useQuery({
    queryKey: ['total-products', user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;
      const { data, error } = await supabase.rpc('count_user_products');
      if (error) throw error;
      return Number(data ?? 0);
    },
    enabled: !!user?.id,
    staleTime: 10_000,
  });

  return { totalProducts, isLoading };
}
